import * as React from 'react';
import {connect} from "react-redux";
import authDispatch from '../../ReduxRequests/Dispatch/authDispatch';
import enquiryDispatch from '../../ReduxRequests/Dispatch/enquiryDispatch';
import authState from '../../ReduxRequests/State/authState';
import enquiryState from '../../ReduxRequests/State/enquiryState';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import EnquiryForm from './EnquiryForm';
import EnquiryResult from './EnquiryResult';
import EnquiryResultTableView from './EnquiryResultTableView';
import MaintenanceNotification from '../Maintenance/MaintenanceNotification';
import Translator from '../Translator/Translator';
import {Auth, CoverNote, Company, Option} from '../../Config/dataModel';
import util from '../../Util/util';
import ErrorHandler from '../ErrorHandler/ErrorHandler';
import Modal from '../Modal/Modal';
import {assertTrue} from '../../Util/errorUtil';
import TranslatorInjectParent from '../Translator/TranslatorInjectParent';
import SwitchLanguage from '../Translator/SwitchLanguage';
import '../../style/enquiry.css';

const pageSpinner = require('../../resource/img/page-loading.gif');

const mapDispatchToProps = (dispatch) => {
    return {
        ...authDispatch(dispatch),
        ...enquiryDispatch(dispatch)
    }
};

const mapStateToProps = (state) => {
    return {
        ...authState(state),
        ...enquiryState(state)
    }
};

interface EnquiryFormProps {
    auth: () => Auth,
    logout: () => void,
    fetchAllInsurers: () => void,
    allInsurers: Company[]
}

interface EnquiryState {
    identity: Option,
    identityNo: string,
    checksum: string,
    insurer: Option,
    insurerOptions: Option[],
    companies: Company[],
    result: CoverNote[],
    recordToBeDisplayed: CoverNote,
    loading: boolean,
    connected: boolean,
    noRecords: boolean
}

class Enquiry extends React.Component <EnquiryFormProps, EnquiryState> {
    public constructor(props: EnquiryFormProps) {
        super(props);
        this.state = {...{
            loading: true,
            connected: true
        }, ...this.getInitialState()};
        this.setRecordToBeDisplayed = this.setRecordToBeDisplayed.bind(this);
        this.clickClose = this.clickClose.bind(this);
        this.clickCancel = this.clickCancel.bind(this);
        this.onError = this.onError.bind(this);
    }

    public getInitialState() {
        return {
            identity: null,
            identityNo: '',
            checksum: '',
            insurer: null,
            insurerOptions: [],
            companies: [],
            result: [],
            recordToBeDisplayed: null,
            noRecords: false
        };
    }

    public componentWillMount() {
        if (this.props.auth()) this.props.logout();
    }

    public componentDidMount() {
        this.props.fetchAllInsurers();
    }

    public componentWillReceiveProps(nextProps: EnquiryFormProps) {
        if (nextProps.allInsurers !== this.props.allInsurers) {
            this.setLoading(false);
            this.setInsurerOptions(nextProps.allInsurers);
        }
    }

    public setInsurerOptions(data: Company[]) {
        let insurers = [];
        for (let i = 0; i < data.length; i++) {
            if (data[i].insurer) insurers.push(data[i]);
        }
        let options = util.getInsurerOptions(insurers);
        this.setState({
            insurer: options[0],
            insurerOptions: options,
            companies: insurers
        });
    }

    public setIdentity(identity: Option, identityNo: string, checksum: string) {
        this.setState({
            identity,
            identityNo,
            checksum
        });
    }

    public setInsurer(insurer: Option) {
        this.setState({
            insurer
        });
    }

    public setResult(result: CoverNote[]) {
        let hasResult = result.length > 0;
        assertTrue(101, hasResult);
        this.setState({
            result,
            recordToBeDisplayed: result.length === 1 ? result[0] : null,
            noRecords: !hasResult
        });
    }

    public setRecordToBeDisplayed() {
        this.setState({
            recordToBeDisplayed: null
        });
    }

    public setLoading(loading: boolean) {
        this.setState({loading});
    }

    public clickCell(idx: number) {
        this.setState({
            recordToBeDisplayed: this.state.result[idx]
        });
    }

    public clickClose() {
        this.setState({
            result: [],
            recordToBeDisplayed: null
        });
    }

    public clickCancel(event: React.MouseEvent<HTMLElement>) {
        event.preventDefault();
        this.setState({
            noRecords: false
        });
    }

    public onError() {
        this.setLoading(false);
        this.setState({
            connected: false
        });
    }

    public getContent() {
        if (this.state.result.length) {
            if (this.state.result.length > 1 && !this.state.recordToBeDisplayed) {
                return (
                    <EnquiryResultTableView
                        list={this.state.result}
                        clickCell={(idx) => this.clickCell(idx)}
                        clickClose={this.clickClose}/>
                );
            }
            else {
                return (
                    <EnquiryResult
                        identity={this.state.identity}
                        identityNo={this.state.identityNo}
                        checksum={this.state.checksum}
                        insurer={this.state.insurer}
                        result={this.state.recordToBeDisplayed}
                        companies={this.state.companies}
                        clickClose={this.state.result.length > 1 ? this.setRecordToBeDisplayed : this.clickClose}/>
                );
            }
        }
        else {
            if (this.state.loading) {
                return (
                    <img className="cmCenter enquiryPageSpinner" src={pageSpinner}/>
                );
            }
            else {
                if (this.state.connected) {
                    return (
                        <EnquiryForm
                            insurerOptions={this.state.insurerOptions}
                            setIdentity={(identity, identityNo, checksum) => this.setIdentity(identity, identityNo, checksum)}
                            setInsurer={(insurer) => this.setInsurer(insurer)}
                            setResult={(result) => this.setResult(result)}/>
                    );
                }
                else return null;
            }
        }
    }

    public render() {
        let content = (
			<div className="cmText modalText modalTextSm">
                <Translator path="enquiry.recordNotFound">
                    As motor policies are undergoing digitisation in phases, if 
                    MIDAS does not return any records, it is probably that your policy has 
                    not been digitised. You may contact your insurer directly to 
                    verify your policy.
                </Translator>
			</div>
        );
        return (
            <div>
                <div className="cmContainer">
                    <Header showMemberPanel={false}/>
                    <TranslatorInjectParent parentPath="enquiry">
                        <MaintenanceNotification isClearable={false}/>
                        <div className="cmHorCenter cmFormContainer enquiry">
                            <div className="enquiryHeader">
                                <SwitchLanguage/>
                                <div className="cmFormTitle">
                                    <Translator path="title">Enquiry</Translator>
                                </div>
                                {this.state.result.length ?
                                    null :
                                    <div className="cmText enquiryMessage">
                                        <Translator path="subtitle">Only records within the last 12 months will be displayed</Translator>
                                    </div>}
                            </div>
                            <div className="enquiryContainer">
                                {this.state.insurerOptions.length ? null :
                                    <div className="cmBtnCenterSpinner">
                                        <ErrorHandler onError={this.onError} displayAtCenter={true}/>
                                    </div>}
                                {this.getContent()}
                            </div>
                        </div>
                    </TranslatorInjectParent>
                </div>
                {this.state.noRecords && 
                <Modal
                    content={content}
                    btn={Translator.translate("enquiry.form.btn.close", "Close")}
                    clickCancel={this.clickCancel}/>}
                <Footer/>
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Enquiry);



// WEBPACK FOOTER //
// ./src/Components/Enquiry/Enquiry.tsx